import MonetaryValue from '@eversports/react-components/primitives/MonetaryValue'
import Text from '@eversports/react-components/primitives/Text'
import { Theme } from '@eversports/react-components/design-tokens/theme'
import { makeStyles } from '@mui/styles'
import { Localized } from '../../localization/react'
import { Interval, Promotion } from '../../typings/Product'
import Price from '../../typings/Price'

const useStyles = makeStyles((theme: Theme) => ({
  membershipPromotionSummary: {
    backgroundColor: theme.palette.lightGray,
    padding: 8,
    borderRadius: 4,
    width: 'fit-content',
  },
}))

interface Props {
  promotion: Promotion
  recurringPrice: Price
  paymentInterval: Interval
}

const MembershipPromotionInfo = ({ promotion, recurringPrice, paymentInterval }: Props) => {
  const classes = useStyles()

  // Only INTERVAL_UNIT_MONTHS and INTERVAL_UNIT_WEEKS is possible to set in manager
  const translationId =
    promotion.period.type === 'INTERVAL_UNIT_MONTHS'
      ? 'promotion-price-description-months'
      : 'promotion-price-description-weeks'

  return (
    <Text size="small" className={classes.membershipPromotionSummary}>
      <Localized
        id={translationId}
        params={{
          promotionPrice: <MonetaryValue value={promotion.price.value} currencyCode={promotion.price.currency} />,
          promotionPeriodValue: promotion.period.value,
          recurringPrice: <MonetaryValue value={recurringPrice.value} currencyCode={recurringPrice.currency} />,
          recurringInterval: (
            <Localized
              id="interval"
              params={{ intervalValue: paymentInterval.value, intervalType: paymentInterval.type }}
            />
          ),
        }}
      />
    </Text>
  )
}

export default MembershipPromotionInfo
